import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyDatepickerModule } from '@vendasta/galaxy/datepicker';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { MatTabsModule } from '@angular/material/tabs';
import { GoogleMapsModule } from '@angular/google-maps';
import { UIKitModule } from '@vendasta/uikit';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatDividerModule } from '@angular/material/divider';
import { GalaxyEmptyStateModule } from '@vendasta/galaxy/empty-state';
import { LocalSeoKeywordDialogComponent } from '../local-seo-keyword-dialog/local-seo-keyword-dialog.component';
import { MileToKilometerPipe } from '../local-seo-settings-dialog/local-seo-settings-dialog.component';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDialogModule } from '@angular/material/dialog';
import { MatListModule } from '@angular/material/list';
import { VaFormsModule } from '@vendasta/forms';
import { GalaxyLoadingSpinnerModule } from '@vendasta/galaxy/loading-spinner';
import { DeltaComponent } from '../../delta/delta.component';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { ChartModule } from '@bit/vendasta.planets.chart';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { MatRadioModule } from '@angular/material/radio';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { LocalSeoKeywordsStatsCardsModule } from '../../keyword-stats-cards/local-seo-keywords-stats-cards.module';
import { LocalSEOTableModule } from '../../local-seo-table/local-seo-table.module';
import { LocalSeoSettingsDialogComponent } from '../local-seo-settings-dialog/local-seo-settings-dialog.component';
import { InfoBannerComponent } from '../../info-banner/info-banner.component';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import { KeywordTrackingComponent } from './keyword-tracking.component';
import { LocalSeoPageTitleActionComponent } from '../local-seo-page-title-action/local-seo-page-title-action.component';
import { LexiconModule } from '@galaxy/lexicon';
import en from '../../assets/i18n/en_devel.json';
import { GalaxyCheckboxModule } from '@vendasta/galaxy/checkbox';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    LocalSeoKeywordDialogComponent,
    MileToKilometerPipe,
    LocalSeoSettingsDialogComponent,
    InfoBannerComponent,
    KeywordTrackingComponent,
    LocalSeoPageTitleActionComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyDatepickerModule,
    MatCardModule,
    MatIconModule,
    MatTabsModule,
    GoogleMapsModule,
    UIKitModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatDividerModule,
    GalaxyEmptyStateModule,
    MatButtonModule,
    MatDialogModule,
    MatListModule,
    VaFormsModule,
    GalaxyLoadingSpinnerModule,
    DeltaComponent,
    MatButtonToggleModule,
    NgxChartsModule,
    GalaxyFormFieldModule,
    MatSelectModule,
    ChartModule,
    GalaxyAlertModule,
    MatRadioModule,
    GalaxyBadgeModule,
    LocalSEOTableModule,
    LocalSeoKeywordsStatsCardsModule,
    GalaxyPageModule,
    LexiconModule.forChild({
      componentName: 'common/local-seo',
      baseTranslation: en,
    }),
    GalaxyCheckboxModule,
    FormsModule,
  ],
  exports: [KeywordTrackingComponent, LocalSeoPageTitleActionComponent],
})
export class KeywordTrackingModule {}
